export default {
  root: {
    class: [
      // Flex
      'flex flex-col',

      // Shape
      'rounded',
      'shadow-md',

      // Color
      'bg-white',
      'overflow-auto border border-surface-200 dark:border-surface-700 rounded',
      'text-surface-700 dark:text-surface-0'
    ]
  },
  body: {
    class: [
      // Flex
      'flex flex-col'
    ]
  },
  caption: {
    class: [
      // Flex
      'flex flex-col',
      'gap-2'
    ]
  },
  title: ({ props }) => {
    return {
      class: [
        {
          'p-3 md:p-4': props.ptOptions?.variant === 'sidebar',
          'p-4 md:p-6': props.ptOptions?.variant !== 'sidebar'
        },

        'text-[18px] md:text-[20px] font-light leading-[170%]',

        'bg-surface-50 dark:bg-surface-900',
        'border-b'
      ]
    }
  },
  subtitle: {
    class: [
      // Font
      'font-normal',

      // Spacing
      'mb-0',

      // Color
      'text-surface-600 dark:text-surface-0/60'
    ]
  },
  content: ({ props }) => ({
    class: [
      {
        'p-0': props.ptOptions?.variant === 'sidebar',
        'p-4 md:p-6': props.ptOptions?.variant !== 'sidebar'
      }
    ]
  }),
  footer: {
    class: 'p-0'
  }
}
